var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16342",
    "data-name": "Group 16342",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.093,
    height: 39,
    viewBox: "0 0 38.093 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    width: 38.093,
    height: 39,
    transform: "translate(0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-center-operator",
    transform: "translate(4.2 3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M31.788,28.878v4.43H1.581V28.877c0-2.092,1.8-4.667,4.008-5.714l4.9-2.329,3.4,7.092L15.641,23.2a5.586,5.586,0,0,0,1.043.152,5.6,5.6,0,0,0,1.043-.152l1.655,4.492,3.338-6.938,5.063,2.407C29.984,24.209,31.788,26.784,31.788,28.878ZM6.036,13.351v-3.2A1.532,1.532,0,0,1,6.745,8.86a10.008,10.008,0,0,1,19.884,0,1.534,1.534,0,0,1,.708,1.292v3.2a1.539,1.539,0,0,1-3.079,0v-.672c-.833,4.189-3.9,8.077-7.571,8.077s-6.738-3.889-7.571-8.077v.672a1.535,1.535,0,0,1-1.083,1.462,8.979,8.979,0,0,0,3.849,5.066,1.57,1.57,0,0,1,1.208.128c.682.354,1.029,1.044.771,1.536a1.251,1.251,0,0,1-1.7.247,1.489,1.489,0,0,1-.851-1.109,9.973,9.973,0,0,1-4.3-5.9A1.536,1.536,0,0,1,6.036,13.351ZM7.794,8.5a.449.449,0,0,1,.135.021.489.489,0,0,1,.248.215,1.534,1.534,0,0,1,.763.722c.454-4.254,3.743-6.5,7.744-6.5s7.29,2.25,7.744,6.5A1.527,1.527,0,0,1,25.6,8.634,9.015,9.015,0,0,0,7.794,8.5Z",
    transform: "translate(-1.581 0)",
    fill: "#f9b316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy6);
export default __webpack_public_path__ + "static/media/why6.f9905903689d1c681bd219c44b977d27.svg";
export { ForwardRef as ReactComponent };